// =============================================================================
// MODELS — Issue domain types (mirrors issue-api openapi schemas)
// =============================================================================

export type Severity = 'critical' | 'major' | 'minor' | 'cosmetic';

export type Status =
  | 'open'
  | 'in_progress'
  | 'fixed'
  | 'deferred'
  | 'closed'
  | 'duplicate'
  | 'wontfix';

export const SEVERITIES: Severity[] = ['critical', 'major', 'minor', 'cosmetic'];

export const STATUSES: Status[] = [
  'open',
  'in_progress',
  'fixed',
  'deferred',
  'closed',
  'duplicate',
  'wontfix',
];

export interface Attachment {
  id: number;
  issue_id: number;
  storage_id: number;
  role: string;
  caption: string | null;
  created_at: string;
}

export interface Comment {
  id: number;
  issue_id: number;
  author: string;
  author_type: string;
  body: string;
  created_at: string;
}

export interface Issue {
  id: number;
  title: string;
  description: string;
  severity: Severity;
  status: Status;
  component: string | null;
  tags: string[];
  reporter: string;
  reporter_type: string;
  assignee: string | null;
  tenant_id: string;
  file_pointer: string | null;
  duplicate_of: number | null;
  fixed_at: string | null;
  fixed_by: string | null;
  resolution_commit: string | null;
  resolution_summary: string | null;
  created_at: string;
  updated_at: string;
  metadata_json: Record<string, unknown>;
}

export interface IssueDetail extends Issue {
  attachments: Attachment[];
  comments: Comment[];
}

export interface IssueListResponse {
  items: Issue[];
  total: number;
  limit: number;
  offset: number;
}

export interface IntakeResponse {
  id: number;
  title: string;
  severity: Severity;
  component: string | null;
  tags: string[];
  ai_confidence: number;
  duplicate_candidates: number[];
  url: string;
}

export interface ListFilters {
  status?: Status;
  severity?: Severity;
  component?: string;
  assignee?: string;
  q?: string;
  limit?: number;
  offset?: number;
}
